var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKsm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 301 301",
    style: {
      enableBackground: "new 0 0 301 301"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150.5,
    cy: 150.5,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.5,82.2c-3.7-2.9-8.2-7-16.3-8c-7.6-1-15.3,4.1-20.6,7.5c-5.2,3.4-15.1,13.3-19.2,16.3 c-4.1,3-14.6,5.8-31.4,15.9s-83,52.6-83,52.6l17.2,0.2l-76.7,39.5h7.7l-11,8.4c0,0,9.8,2.6,17.9-2.6v2.4c0,0,91.3-36,109-26.7 l-10.8,3.2c0.9,0,18.3,1.1,18.3,1.1c0.9,7.3,4.9,13.8,11,17.8c10.5,6.9,10.7,10.7,10.7,10.7s-5.4,2.2-5.4,5c0,0,8-2.4,15.5-2.2 c4.7,0.2,9.4,0.9,14,2.2c0,0-0.6-3-7.8-5c-7.2-2-14.4-9.9-17.9-14.2c-4.4-5.6-5.5-13-2.9-19.6c2.5-6.5,11.3-10.1,29.3-19.4 c21.3-11,26.2-19.2,29.2-25.6c3-6.4,7.5-19.1,10-25c3.2-7.7,7-11.8,10.3-14.2c3.2-2.4,17.6-7.8,17.6-7.8S267,85,263.5,82.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsm);
export default __webpack_public_path__ + "static/media/KSM.bbc60230e7df66e0d9277e89ea284112.svg";
export { ForwardRef as ReactComponent };